/** srcSet for photos that ship with -640 and -960 copies next to the original (full width in px). */
export const photoSet = (src, full) => {
  const base = src.replace(/\.jpg$/, "");
  return `${base}-640.jpg 640w, ${base}-960.jpg 960w, ${src} ${full}w`;
};
